import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IMpxRepository } from '../../repositories/interfaces/IMpxRepository';
import { IChannelCategoriesResponse } from '../../../entity/interface/iChannelCategoriesResponse';

export interface IGetChannelCategoriesUseCase {
    execute(guids: string, country: string, isKidsMode: boolean): Promise<IChannelCategoriesResponse>;
}

export class GetChannelCategoriesUseCase implements IGetChannelCategoriesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get mpxRepository(): IMpxRepository {
        return container.resolve<IMpxRepository>(DI.REPOSITORIES.IMpxRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(guids: string, country: string, isKidsMode: boolean): Promise<IChannelCategoriesResponse> {
        return this.mpxRepository.getChannelCategories(guids, country, isKidsMode);
    }
}
